import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import InputText from '../../../components/Inputs/InputText';

const TakeInProcessDialog = ({ visible, onConfirm, onHide }) => {
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!visible) {
      setTimeout(() => setMessage(''), 250);
    }
  }, [visible]);

  const handleConfirm = () => {
    onConfirm(message.trim() || undefined);
  };

  return (
    <Dialog open={visible} onClose={onHide} maxWidth="sm" fullWidth>
      <DialogTitle>Tomar solicitud en trámite</DialogTitle>
      <DialogContent>
        <DialogContentText>
          La solicitud pasará a estado "En proceso". Mientras permanezca así, el alumno no podrá cancelarla.
        </DialogContentText>
        <InputText
          name="message"
          value={message}
          onChange={e => setMessage(e.target.value)}
          label="Mensaje para el estudiante"
          placeholder="Opcional"
          InputLabelProps={{ shrink: true }}
          inputProps={{ maxLength: 500 }}
          rows={4}
          multiline
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onHide} color="secondary">Cancelar</Button>
        <Button onClick={handleConfirm} variant="contained" color="primary">Confirmar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TakeInProcessDialog;
